
import { DateRangePickerComponent } from '@jms/ui/ui.appointments.date.range.picker';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { AvatarModule } from '@jms/ui/ui.avatar';
import { LuxonCalendarModule } from '@workbuddy/ui/fields/luxon.calendar';
import { AppointmentResourcePickerModule, EntityItemModule } from '@jms/ui/ui.standalone.pickers';
import { TooltipModule } from '@jms/ui/ui.tooltip';
import { PipeModule } from '@jms/utils/util.pipes';
import { NgSelectModule } from '@ng-select/ng-select';
import { FullCalendarModule } from '@fullcalendar/angular';


import { AppointmentCalendarComponent, AppointmentEditorComponent, EventCardComponent, ResourceComponent } from './components';
import { TimeSimplePipe } from '@jms/utils/util.pipes';
import { PortalContactPickerModule } from '@jms/ui/ui.portal.pickers.contact';
import { TextFieldModule } from '@angular/cdk/text-field';
import { OnlyNumbersModule } from '@jms/ui/ui.standalone.directives';


@NgModule({
	declarations: [
		AppointmentEditorComponent,
		ResourceComponent,
		AppointmentCalendarComponent,
		EventCardComponent
	],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		TextFieldModule,

		LuxonCalendarModule,
		DateRangePickerComponent,
		AppointmentResourcePickerModule,
		NgSelectModule,
		EntityItemModule,
		FullCalendarModule,
		AvatarModule,
		TooltipModule,
		PipeModule,
		TimeSimplePipe,
		PortalContactPickerModule,
		OnlyNumbersModule,
	],
	exports: [
		AppointmentEditorComponent,
		AppointmentCalendarComponent,
	],
})
export class AppointmentEditorModule { }
